import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Attempted hydrateRoot (2026-09): /automation-center hydrated cleanly but / throws
// React #418 — snapshots bake API-driven content (banner, live stats) with no serialized
// state, so markup can't match the fresh render. Clean fix = real SSR/state snapshotting.
// Per audit instruction: not forcing it. createRoot replaces the prerendered DOM.
// hydrateRoot attempted twice (2026-09, audit rounds): every route throws #418 because
// (1) SiteGate first-renders a gate shell while /api/gate/status resolves, and (2) the
// SEO-critical sections (library archive index, automation-center package cards, banner)
// are API-driven — their data exists in the snapshot but not in the first client render.
// Deterministic hydration requires serializing captured API state into the raw HTML
// (window.__SMI_STATE__ + initialData plumbing). Stop-clause invoked; createRoot stays.
ReactDOM.createRoot(container).render(app);
